module.exports = __webpack_public_path__ + "e912a7a5dfc67d295b49d2244fab3a51.pdf";